export default (ctx, inject) => {
  const currency = {
    get: () => {
      const currency = ctx.store.state.account.currency

      if (currency === 'GBP') return ctx.app.i18n.t('pound')

      return ctx.app.i18n.t('euro')
    },
    getIcon: () => {
      const currency = ctx.store.state.account.currency

      if (currency === 'GBP') return 'pound'

      return 'euro'
    },
    getCoinAbbreviation: () => {
      const currency = ctx.store.state.account.currency

      if (currency === 'GBP') return ctx.app.i18n.t('pence')

      return ctx.app.i18n.t('cent')
    },
    getCurrencyPerKwh: () => {
      const accountCurrency = ctx.store.state.account.currency
      const currency = accountCurrency === 'GBP' ? '' : ctx.app.$currency.get()
      const coin = ctx.app.$currency.getCoinAbbreviation()
      const kWh = ctx.app.i18n.t('kwh')

      return `${currency}${coin}/${kWh}`
    }
  }

  ctx.$currency = currency
  inject('currency', currency)
}
